import noAccents from './noAccents';

/**
 * Returns a "handleized" version of a string suitable for URLs and file names.<br>
 * Based on {@link https://github.com/Shopify/liquid Liquid} by Shopify
 *
 * @param {string} content - The string to handleize
 * @param {string} [separator=-] - The character to use as a separator.
 * @param {string} [replacement=Empty string] - The replacement to use for invalid characters.
 * @returns {string} The handleized string.
 * @example
 * var myString = 'My áccentéd string$.';
 *
 * // returns 'my-accented-string'
 * handleize(myString);
 *
 * // returns 'my_accented_string##'
 * handleize(myString, '_', '#');
 */
export default (content, separator = '-', replacement = '') => {
  let output = String(content);
  // handles should be lowercase
  output = output.toLowerCase();
  // strip combining diacritics such as accents
  output = noAccents(output, true, replacement);
  // handles should begin and end with an alphanumeric
  output = output.replace(/^[^a-z0-9_]+|[^a-z0-9_]+$/g, replacement);
  // replace runs of non-alphanumerics with the separator
  output = output.replace(/[^a-z0-9_]+/g, separator);
  return output;
};
